import React, { useCallback, useState } from 'react';
import { Screen, StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Box } from '@bonanza-social/moonlight';

import AttestationSection from '../components/AttestationSection/AttestationSection';
import AttestationSummary from '../components/AttestationSummary/AttestationSummary';

function DetailsAttestationScreen() {
  const [openSection, setOpenSection] = useState<boolean>(false);
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleOpenSection = useCallback(() => setOpenSection(true), []);

  return (
    <Screen paddingHorizontal="space-100">
      <Box flex={1} padding="space-400" justifyContent="center">
        {openSection ? (
          <AttestationSection onClose={navigation.goBack} />
        ) : (
          <AttestationSummary
            openAttestationSection={handleOpenSection}
            onClose={navigation.goBack}
          />
        )}
      </Box>
    </Screen>
  );
}

export default DetailsAttestationScreen;
